import * as React from 'react'

import { cn } from '@shared/ui/lib/utils'
import './card.css'

function Card({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn(
        'rounded-lg border p-6 shadow-sm',
        className,
      )}
      data-slot="card"
      {...props}
    />
  )
}

function CardHeader({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('mb-5 flex flex-col gap-1.5 sm:flex-row sm:items-start sm:justify-between', className)}
      data-slot="card-header"
      {...props}
    />
  )
}

function CardHeading({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('grid gap-1.5', className)}
      data-slot="card-heading"
      {...props}
    />
  )
}

function CardTitle({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'h2'>) {
  return (
    <h2
      className={cn('m-0 text-lg font-bold leading-tight', className)}
      data-slot="card-title"
      {...props}
    />
  )
}

function CardDescription({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'p'>) {
  return (
    <p
      className={cn('m-0 text-sm leading-6', className)}
      data-slot="card-description"
      {...props}
    />
  )
}

function CardAction({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('flex flex-col gap-2 sm:flex-row sm:items-center', className)}
      data-slot="card-action"
      {...props}
    />
  )
}

function CardContent({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('grid gap-4', className)}
      data-slot="card-content"
      {...props}
    />
  )
}

function CardFooter({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('mt-5 flex flex-col gap-2 sm:flex-row sm:items-center', className)}
      data-slot="card-footer"
      {...props}
    />
  )
}

export {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardHeading,
  CardTitle,
}
